import { Component, ChangeDetectionStrategy } from '@angular/core';
import {PendingRequest, OpenRequestsService} from '../services/open-requests.service';

@Component({
    selector: 'app-open-requests',
    imports: [],
    templateUrl: './open-requests.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './open-requests.component.scss'
})
export class OpenRequestsComponent {

  constructor(
    private requestCountService: OpenRequestsService
  ) {

  }

  getRequests(): PendingRequest[] {
    return this.requestCountService.getRequests();
  }

}
